import script from "./WorkbenchHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkbenchHeader.vue?vue&type=script&setup=true&lang=js"

import "./WorkbenchHeader.vue?vue&type=style&index=0&id=e921c3e6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e921c3e6"]])

export default __exports__